<template>
  <label v-if="!info" :class="labelCssClass" class="col-form-label">{{
    label
  }}</label>
  <div v-else :class="labelCssClass">
    <div class="row">
      <label class="col-form-label" :class="infoIconLabel">{{ label }}</label>
      <span class="col-auto" :class="infoIconWrapper"
        ><img
          src="@/assets/info.svg"
          :style="infoIcon"
          class="info align-middle ml-3"
          data-toggle="tooltip"
          data-placement="top"
          v-bind:title="info"
      /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'formlabel',
  props: {
    label: {
      required: true
    },
    info: {
      required: true
    },
    labelCssClass: {
      required: true
    },
    infoIconWrapper: {
      required: true
    }
  },
  data(){
    return {
      infoIcon: { height: '18px' }
    };
  },
  computed: {
    infoIconLabel() {
      return 'col';
    }
  }
};
</script>

<style>
</style>